import { BorderStyleProps } from '../../../types';

export const getBorderStyleProps = (): BorderStyleProps => {
  return {
    borderBlockColor: 'text-core-default',
    borderInlineColor: 'text-core-default',
    borderBlockStyle: 'solid',
    borderInlineStyle: 'solid',
    borderBlockWidth: '100',
    borderInlineWidth: '100',
  };
};

export const getCircleShapeStyleProps = (): BorderStyleProps => {
  return {
    borderStartStartRadius: 'full',
    borderStartEndRadius: 'full',
    borderEndStartRadius: 'full',
    borderEndEndRadius: 'full',
  };
};

export const getRoundedShapeStyleProps = (): BorderStyleProps => {
  return {
    borderStartStartRadius: '100',
    borderStartEndRadius: '100',
    borderEndStartRadius: '100',
    borderEndEndRadius: '100',
  };
};
